import { useEffect, useRef, useState } from "react";
import { useAbortController } from "../../../hooks/useAbortController";
import TrafficSourcesAutocomplete from "./TrafficSourcesAutocomplete";
import { PublisherOrSiteOption } from "../../../utils/types";
import { TrafficSources } from "../../../services/TrafficSources";
import LoadingMessage from "../../notifications/LoadingMessage";

interface TrafficSourcesAutocompleteWrapperProps {
  setTrafficSourcesStorage: (trafficSources:PublisherOrSiteOption[]) => void;
  trafficSourcesStorage: PublisherOrSiteOption[];
}

function TrafficSourcesAutocompleteWrapper(props: TrafficSourcesAutocompleteWrapperProps) {
  const { setTrafficSourcesStorage, trafficSourcesStorage } = props;
  const { createController } = useAbortController();
  const [clinkableTrafficSources, setClinkableTrafficSources] = useState<PublisherOrSiteOption[]>(null);
  const [selectedClinkableTrafficSources, setSelectedClinkableTrafficSources] = useState<PublisherOrSiteOption[]>(trafficSourcesStorage ? trafficSourcesStorage : []);
  const trafficSourcesRef = useRef(null);

  const handleTrafficSourcesChange = (selectedValues:PublisherOrSiteOption[], isSelectedFromCheckbox:boolean) => {
    const newSelectedTrafficSources:PublisherOrSiteOption[] = [];
    selectedValues.forEach((selectedValue:PublisherOrSiteOption) => {
      const found = newSelectedTrafficSources.find(newSelectedTrafficSource => newSelectedTrafficSource.id === selectedValue.id);
      if (found) {
        newSelectedTrafficSources.splice(newSelectedTrafficSources.indexOf(found), 1);
      } else {
        newSelectedTrafficSources.push(selectedValue);
      }
    });

    setSelectedClinkableTrafficSources(newSelectedTrafficSources);
    if (!isSelectedFromCheckbox) {
      setTrafficSourcesStorage(newSelectedTrafficSources);
    }
  }

  const onMenuToggle = (isOpen:boolean) => {
    if (!isOpen) {
      trafficSourcesRef.current.setState((prevState:any) => ({...prevState,text: ""}));
      if (trafficSourcesStorage) {
        if (!selectedClinkableTrafficSources.every( trafficSource => trafficSourcesStorage.indexOf(trafficSource) >= 0 ) || trafficSourcesStorage.length !== selectedClinkableTrafficSources.length) {
          setTrafficSourcesStorage(selectedClinkableTrafficSources);
        }
      }
    }
  }

  useEffect(() => {
    TrafficSources.getTrafficSourcesClinkables(createController(), setClinkableTrafficSources);
  }, [createController]);

  if (!clinkableTrafficSources) {
    return <LoadingMessage message="Loading Traffic Sources..." style={{ maxWidth: "525px" }} />;
  };

  return (<TrafficSourcesAutocomplete
            onChange={(selectedValues: PublisherOrSiteOption[], isSelectedFromCheckbox) => handleTrafficSourcesChange(selectedValues, isSelectedFromCheckbox)} 
            options={clinkableTrafficSources}
            reactRef={trafficSourcesRef}
            style={{ maxWidth: "525px" }}
            selected={selectedClinkableTrafficSources}
            selectedForCheckboxes={selectedClinkableTrafficSources}
            onMenuToggle={onMenuToggle}
            multiple
            useCheckbox
          />);
}

export default TrafficSourcesAutocompleteWrapper;